import React from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import './CustomDatePickerStyle.css';
import useDarkMode from '../../../../hooks/useDarkMode';
import { useEffect } from 'react';

dayjs.extend(customParseFormat);

const CustomDatePicker = ({
	disabled = false,
	minDate = null,
	maxDate = null,
	value = null,
	onChange = () => {},
	styleValue = null,
}) => {
	const currentMonth = dayjs().month();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	const dateRender = (currentDate) => {
		let isactive = currentDate.month() === currentMonth;
		if (minDate) {
			isactive =
				minDate <= dayjs(currentDate, 'YYYY-MM-DD')
					? currentDate.month() === minDate.month()
					: false;
		}

		if (value) {
			if (minDate) {
				isactive =
					minDate <= dayjs(currentDate, 'YYYY-MM-DD')
						? currentDate.month() === value.month()
						: false;
			} else {
				isactive = currentDate.month() === value.month();
			}

			//
			// if(maxDate){
			// 	isactive = minDate<=dayjs(currentDate, 'YYYY-MM-DD') && maxDate>=dayjs(currentDate, 'YYYY-MM-DD') ?currentDate.month() === currentMonth:false;
			//
			// }
		}

		return (
			<div
				className={`dev-a ${isactive ? 'active' : 'inactive'}`}
				// style={{
				// 	backgroundColor: isactive ? '#dceaf4' : '#f0f0f0',
				// 	width: '100%',
				// 	height: '100%',
				// 	display: 'flex',
				// 	fontSize: '12px',
				// 	alignItems: 'center',
				// 	justifyContent: 'center',
				// 	color: '#000',
				// }}
			>
				{currentDate.date()}
			</div>
		);
	};

	return (
		<ConfigProvider
			theme={{
				components: {
					DatePicker: {
						colorPrimary: '#6c5dd3',
						colorTextPlaceholder: '#fff',
						cellHeight: 18,
						cellWidth: 28,
						colorBgElevated: '#f4f4f4',
						fontSize: 13,
						padding: 10,
						colorTextDisabled: disabled ? '#242323' : '#00000040',
						// colorTextDisabled: disabled ? '#fff' : '#00000040',
					},
				},
			}}>
			<DatePicker
				disabled={disabled}
				// style={{
				// 	border: styleValue ? '2px solid red' : '2px solid transparent',
				// 	fontWeight: 'bold',
				// }}
				// className={`form-control ${disabled ? 'ant-picker-disabled' : ''}`}
				className={`form-control ${disabled ? 'ant-picker-disabled' : ''} ${
					styleValue ? 'error' : ''
				}`}
				allowClear={false}
				placeholder=''
				suffixIcon={
					<CalendarOutlined style={{ color: darkModeStatus ? '#fff' : '#6c5dd3' }} />
				}
				format={'DD/MM/YYYY'}
				minDate={minDate}
				maxDate={maxDate}
				value={value}
				onChange={onChange}
				dateRender={dateRender} // Custom render function for dates
			/>
		</ConfigProvider>
	);
};

export default CustomDatePicker;

// import React from 'react';
// import { DatePicker, ConfigProvider } from 'antd';
// import { CalendarOutlined } from '@ant-design/icons';
// import dayjs from 'dayjs';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// import './CustomDatePickerStyle.css';

// dayjs.extend(customParseFormat);

// const CustomDatePicker = ({
// 	disabled = false,
// 	minDate = null,
// 	maxDate = null,
// 	value = null,
// 	onChange = () => {},
// 	styleValue = null,
// }) => {
// 	return (
// 		<ConfigProvider
// 			theme={{
// 				components: {
// 					DatePicker: {
// 						colorPrimary: '#6c5dd3',
// 						colorTextPlaceholder: '#fff',
// 						cellHeight: 18,
// 						cellWidth: 28,
// 						colorBgElevated: '#f4f4f4',
// 						fontSize: 13,
// 						padding: 10,
// 						// colorTextDisabled: disabled ? '#fff' : '#00000040',
// 						colorTextDisabled: '#00000040',
// 					},
// 				},
// 			}}>
// 			<DatePicker
// 			disabledDate={(current) => {
// 				return (minDate && current.isBefore(minDate, 'day')) ||
// 					   (maxDate && current.isAfter(maxDate, 'day'));
// 			}}
// 				disabled={disabled}
// 				style={{
// 					border: styleValue ? '2px solid red' : '2px solid transparent',
// 					fontWeight: 'bold',
// 				}}
// 				className={`form-control ${disabled ? 'ant-picker-disabled' : ''}`}
// 				allowClear={false}
// 				placeholder=''
// 				suffixIcon={<CalendarOutlined style={{ color: '#fff' }} />}
// 				format={'DD/MM/YYYY'}
// 				minDate={minDate}
// 				maxDate={maxDate}
// 				value={value}
// 				onChange={onChange}
// 			/>
// 		</ConfigProvider>
// 	);
// };

// export default CustomDatePicker;
